import React, { memo } from 'react';

// Official Sapient mark (lightning bolt knocked out of a rounded square),
// recolorable via currentColor. Defaults to ink; pass a `color` text-* class
// (e.g. "text-white" on dark) to recolour. Pass `showWordmark` for the full
// "sapient codelabs" lockup.
function AppLogo({
    size = 64,
    className = '',
    onClick,
    color = 'text-text-primary',
    showWordmark = false,
}) {
    return (
        <span
            className={`inline-flex items-center gap-2.5 shrink-0 ${color} ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''} ${className}`}
            onClick={onClick}
            aria-label="Sapient Codelabs"
        >
            <svg
                viewBox="0 0 64 64"
                width={size}
                height={size}
                fill="currentColor"
                aria-hidden="true"
                className="shrink-0"
            >
                <path
                    fillRule="evenodd"
                    d="M14 2h36a12 12 0 0 1 12 12v36a12 12 0 0 1-12 12H14A12 12 0 0 1 2 50V14A12 12 0 0 1 14 2Zm21 9-17 27h12l-4 15 19-29H34l4-13Z"
                />
            </svg>
            {showWordmark && (
                <span
                    className="font-display font-semibold leading-none tracking-tight whitespace-nowrap"
                    style={{ fontSize: Math.round(size * 0.46) }}
                >
                    sapient<span className="opacity-50"> codelabs</span>
                </span>
            )}
        </span>
    );
}

export default memo(AppLogo);
